/**
 * A criterion's evidence, one collapsible group per check type with its count.
 *
 * @module features/proofs/components/EvidenceGroups
 */
import React from 'react';
import { CollapsibleSection } from '@chatsdet/ui';
import { CHECK_TYPE_GROUP_LABEL, evidenceKey, groupEvidence, groupStartsExpanded } from '../evidenceKinds';
import type { ProofEvidence } from '../types';
import { EvidenceItem } from './EvidenceItem';

/**
 * `forceExpanded` (a `?c=N` deep link) opens the groups and only the items that need a look (failed or stale);
 * proved items follow the normal rule, so a deep link does not mount every video and steps fetch.
 * An item's open state is seeded once from `defaultExpanded` and ignores later prop changes.
 */
export const EvidenceGroups: React.FC<{ evidence: ProofEvidence[]; forceExpanded: boolean }> = ({ evidence, forceExpanded }) => (
  <>
    {groupEvidence(evidence).map(({ type, items }) => (
      <CollapsibleSection
        key={type}
        hideBorder
        defaultExpanded={forceExpanded || groupStartsExpanded(items)}
        label={`${CHECK_TYPE_GROUP_LABEL[type]} (${items.length})`}
        bodyClassName="space-y-2 pl-6"
      >
        {items.map((item) => (
          <EvidenceItem key={evidenceKey(item)} evidence={item} defaultExpanded={forceExpanded && item.status.kind !== 'proved'} />
        ))}
      </CollapsibleSection>
    ))}
  </>
);
